import { ReactNode } from 'react';
import { Badge, BlockStack, InlineStack, Text } from '@shopify/polaris';
import { AdminStoreClassification as StoreClassification } from '../../app/models/Admin';

type Props = {
  classification?: StoreClassification | null;
  children?: ReactNode;
};

// Presentation only: the API owns classification, independently of store activity.
export default function AdminStoreClassification({ classification, children }: Props) {
  const kind = classification?.kind ?? 'Unverified';
  const tone = kind === 'Unverified' ? 'warning' : kind === 'Hybrid' ? 'attention' : 'info';

  return (
    <BlockStack gap="200">
      <InlineStack gap="200" blockAlign="center">
        <InlineStack gap="100" blockAlign="center">
          <Text as="span" tone="subdued">Store type</Text>
          <Badge tone={tone}>{kind}</Badge>
        </InlineStack>
        {children}
      </InlineStack>
      <Text as="p">
        {classification?.description || 'Store classification is unavailable. Refresh details after the classification data becomes available.'}
      </Text>
      {classification?.integrations?.length ? (
        <Text as="p" tone="subdued">
          Configured PFV2 integrations: {classification.integrations.join(', ')}.
        </Text>
      ) : null}
      <Text as="p" tone="subdued">
        Based on local configuration; separate from activity and backend routing.
      </Text>
      {(classification?.warnings ?? []).map((warning, index) => (
        <Text key={`classification-warning-${index}`} as="p" tone="caution">{warning}</Text>
      ))}
    </BlockStack>
  );
}
